import { SignalTree } from "../types/signal-tree.type";

export function ensureImpl<T>(
    node: SignalTree<T>,
    factory: () => T
): SignalTree<T> {
    const current = node();

    if (current === undefined || current === null) {
        node.set(factory());
    }

    return node;
}